module.exports = __webpack_public_path__ + "assets/images/tfb-store-close.svg";